import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class DraggingObject extends PureComponent {
  static propTypes = {
    setDraggingObject: PropTypes.func.isRequired,
    objectId: PropTypes.any.isRequired,
    dx: PropTypes.number.isRequired,
    dy: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    draggingObject: PropTypes.any,
    dragging: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    index: PropTypes.number,
    limitNegative: PropTypes.bool,
    limitPositive: PropTypes.bool
  };

  constructor(props) {
    super(props);
    const { x, y } = props;
    this.state = { x, y };
  }

  componentDidUpdate(prevProps) {
    const {
      dx, dy, draggingObject, objectId, x, y, limitNegative, limitPositive
    } = this.props;
    const { dx: dxWas, dy: dyWas } = prevProps;
    const { x0, y0 } = this.state;
    const { x: xWas, y: yWas } = prevProps;
    if (xWas !== x || yWas !== y) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ x, y });
      return;
    }
    if (draggingObject === objectId && (dx !== dxWas || dy !== dyWas)) {
      let newX = x0 + dx;
      if ((newX < 0 && limitNegative) || (newX > 0 && limitPositive)) {
        newX = 0;
      }
      let newY = y0 + dy;
      if ((newY < 0 && limitNegative) || (newY > 0 && limitPositive)) {
        newY = 0;
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ x: newX, y: newY });
    }
  }

  onMouseDown = (e) => {
    const { setDraggingObject, objectId } = this.props;
    const { x, y } = this.state;
    this.setState({ x0: x, y0: y });
    setDraggingObject(objectId, e);
    e.preventDefault();
    e.stopPropagation();
  }

  onMouseUp = (e) => {
    const {
      x, y, x0, y0
    } = this.state;
    const { onClick, index } = this.props;
    if (x === x0 && y === y0 && onClick) {
      // TODO: fix that
      const skipClick = e.target.getAttribute('data') || e.target.parentElement.getAttribute('data') || e.target.parentElement.parentElement.getAttribute('data');
      if (skipClick !== 'skipclick') {
        onClick(index);
      }
    }
  }

  render() {
    const {
      className, children, dragging, objectId, draggingObject
    } = this.props;
    const { x, y } = this.state;
    const style = { top: y, left: x };
    return (
      <div
        className={ className }
        style={ style }
        onMouseDown={ this.onMouseDown }
        onMouseUp={ this.onMouseUp }
      >
        {
          children({ x, y, dragging: dragging && objectId === draggingObject })
        }
      </div>
    );
  }
}
